export const AGENDA_STATUS_OPTIONS = [
  { value: "scheduled", label: "Scheduled" },
  { value: "confirmed", label: "Confirmed" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "no_show", label: "No Show" },
];

export const AGENDA_LOCATION_TYPE_OPTIONS = [
  { value: "club", label: "Club" },
  { value: "online", label: "Online" },
  { value: "phone", label: "Phone" },
];

export const agendaResources = [
  {
    key: "appointment-types",
    label: "Appointment Types",
    endpoint: "/appointment-types",
    description: "Configure the appointment categories available to staff when booking members.",
    tableFields: [
      { name: "name", label: "Name" },
      { name: "code", label: "Code" },
      { name: "duration_minutes", label: "Duration" },
      { name: "requires_confirmation", label: "Requires Confirmation", valueGetter: (row) => (row?.requires_confirmation ? "Yes" : "No") },
      { name: "is_active", label: "Active", valueGetter: (row) => (row?.is_active ? "Yes" : "No") },
    ],
    formFields: [
      { name: "code", label: "Code", type: "text" },
      { name: "name", label: "Name", type: "text" },
      { name: "duration_minutes", label: "Duration (Minutes)", type: "number", defaultValue: 60 },
      { name: "color", label: "Color", type: "text", nullable: true, placeholder: "#3f51b5" },
      { name: "requires_confirmation", label: "Requires Confirmation", type: "boolean", defaultValue: false },
      { name: "is_active", label: "Active", type: "boolean", defaultValue: true },
    ],
  },
  {
    key: "appointments",
    label: "Appointments",
    endpoint: "/appointments",
    description: "Create and manage member appointments. The backend validates conflicts for staff, members, and rooms.",
    tableFields: [
      { name: "title", label: "Title", valueGetter: (row) => row?.title || row?.appointment_type_name || "Appointment" },
      { name: "appointment_type_id", label: "Type", valueGetter: (row) => row?.appointment_type_name || row?.type?.name || row?.appointment_type_id },
      { name: "customer_user_id", label: "Member", valueGetter: (row) => row?.customer_name || row?.customer?.name || row?.customer?.email || row?.customer_user_id },
      { name: "staff_user_id", label: "Staff", valueGetter: (row) => row?.staff_name || row?.staff?.name || row?.staff?.email || row?.staff_user_id },
      { name: "starts_at", label: "Starts" },
      { name: "ends_at", label: "Ends" },
      { name: "status", label: "Status" },
    ],
    formFields: [
      { name: "appointment_type_id", label: "Appointment Type", type: "select", optionSource: { endpoint: "/appointment-types", valueField: "id", labelFields: ["name", "code"] } },
      { name: "customer_user_id", label: "Member", type: "select", optionSource: { endpoint: "/users?userType=CUSTOMER", valueField: "id", labelFields: ["name", "email"] } },
      { name: "staff_user_id", label: "Staff", type: "select", optionSource: { endpoint: "/users?userType=EMPLOYEE", valueField: "id", labelFields: ["name", "email"] } },
      { name: "room_id", label: "Room", type: "select", nullable: true, optionSource: { endpoint: "/rooms", valueField: "id", labelFields: ["name", "code"] } },
      { name: "starts_at", label: "Start", type: "datetime" },
      { name: "ends_at", label: "End", type: "datetime" },
      { name: "status", label: "Status", type: "select", defaultValue: "scheduled", options: AGENDA_STATUS_OPTIONS },
      { name: "location_type", label: "Location Type", type: "select", defaultValue: "club", options: AGENDA_LOCATION_TYPE_OPTIONS },
      { name: "title", label: "Title", type: "text", nullable: true },
      { name: "description", label: "Description", type: "text", nullable: true },
      { name: "location_notes", label: "Location Notes", type: "text", nullable: true },
      { name: "internal_notes", label: "Internal Notes", type: "text", nullable: true },
    ],
  },
];

